import 'typeface-poppins/index.css';
import 'typeface-roboto/index.css';

import '@/assets/fonts/fontawesome-pro-5.9.0-web/css/all.css';
import '@/assets/fonts/line-awesome/css/line-awesome.css';
import '@/assets/fonts/flaticon/css/flaticon.css';
import 'vue-search-select/dist/VueSearchSelect.css';

import '@/config/bootstrap';

import 'perfect-scrollbar/css/perfect-scrollbar.css';
import '@/assets/fonts/metronic/css/styles.css';
import '@/assets/style/style.bundle.css';
import '@/assets/style/customStyle.css';

import Vue from 'vue';
import App from '@/App.vue';

import '@/config/axios';
import '@/config/toasted';
import '@/config/filters';

import router from '@/config/router';
import store from '@/store/store';

import VueMask from 'v-mask';

Vue.use(VueMask);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
